import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskTickComplete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.3 11q.6 0 .7.8V15a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3.2a.7.7 0 1 1 1.5 0V15q0 .5.5.5h14q.5 0 .5-.5v-3.2q0-.8.8-.8M14 3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5q.2-1.8 2-2zM6 4.5q-.5 0-.5.5v7q0 .5.5.5h8q.5 0 .5-.5V5q0-.5-.5-.5zm5.1 2a.7.7 0 0 1 1.3.9L10 10.7l-.6.3-.6-.3-1-1.1a.7.7 0 0 1 1-1l.5.4z" })
});
export default SvgTaskTickComplete;
